import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { LOGIN_REQUEST, LOGOUT_REQUEST, loginSuccess, loginFailure } from '../actions/authorizeAction';
import { API_PATH}  from '../config';

const LOGIN_API = `${API_PATH}/login`;

const loginApi = (userInfo) => {
   return axios.post(LOGIN_API, userInfo)
   .then( (response) => response.data);
}

function* login(action) {

   let fetch = undefined;
   try {
      fetch = yield call(loginApi, action.userInfo);
      if (fetch) {
         if (fetch.success) {
            sessionStorage.setItem('loginInfo', JSON.stringify(fetch.result));
            yield put(loginSuccess(fetch.result));
         } else {
            yield put(loginFailure('登入失敗, 帳號或密碼錯誤 !'));
         }
      } else {
         yield put(loginFailure('登入失敗, 資料錯誤 !'));
      }

   } catch (error) {
      yield put(loginFailure(`登入失敗, ${error.message}`));
   }
}

function* logout(action) {
   try {
      sessionStorage.removeItem('loginInfo');
      yield
   } catch (error) {
      console.log(error.message);
   }
}


export function* watchAuthorizeAction() {
   yield takeEvery(LOGIN_REQUEST, login);
   yield takeEvery(LOGOUT_REQUEST, logout);
}